// Axios is used for making HTTP requests
import axios from "axios";
// js-cookie helps in accessing browser cookies
import Cookies from "js-cookie";

// Utility to retrieve the access token from cookies
const getToken = () => Cookies.get("accessToken");

// Create a reusable Axios instance
const axiosInstance = axios.create();

// Add a response interceptor to handle global error scenarios like unauthorized access
axiosInstance.interceptors.response.use(
  (response) => response, // Return response as is
  (error) => {
    // Redirect to login on 401 Unauthorized
    if (error.response && error.response.status === 401) {
      sessionStorage.removeItem("accessToken");
      window.location.href = "/";
    }
    return Promise.reject(error); // Pass error to caller
  }
);

// API wrapper for authorized endpoints using bearer token
export const api = {
  // POST request with Authorization header
  post: (url, data) => {
    const token = getToken();
    return axios.post(url, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  // DELETE request with optional request body
  delete: (url, data) => {
    const token = getToken();
    return axios.delete(url, {
      headers: { Authorization: `Bearer ${token}` },
      data: data ? data : {}, // DELETE can send data too
    });
  },

  // GET request with Authorization header
  get: (url, params) => {
    const token = getToken();
    return axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  // PUT request to update resources
  put: (url, data) => {
    const token = getToken();
    return axios.put(url, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  // PATCH request for partial updates
  patch: (url, data) => {
    const token = getToken();
    return axios.patch(url, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};

// Auth-specific API wrapper (no token needed, used during login/forgot password)
export const authApi = {
  post: (url, data) => axios.post(url, data),
};
